import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { Gender } from './Enums'
/**
* Class WebUserProfileUpdate
*  Данные для обновления профиля пользователя
*/
export class WebUserProfileUpdate extends ActiveModel {

/**
  * surname
  * Фамилия<br>
  */
  @ActiveField('')
  surname: string = ''


/**
  * name
  * Имя<br>
  */
  @ActiveField('')
  name: string = ''


/**
  * patronymic
  * Отчество<br>
  */
  @ActiveField()
  patronymic?: string


  /**
  * gender
  * словарь значений публикуется под именем `Gender`  *   * Пол<br>  *   * - `Male` Мужской  *   * Мужской  * - `Female` Женский  *   * Женский  *   */
  @ActiveField()
  gender?: Gender


/**
  * dateOfBirth
  * Дата рождения<br>
  */
  @ActiveField()
  dateOfBirth?: string
}
